import type Big from 'big.js'

import type { BUTTON_TYPE } from '$lib/components/Common/Buttons/Button_types'
import type { CalculatedDocumentItem, DocTax, ServerDocumentItem } from '$lib/components/document/doc_types'
import type { CalculationType, TaxType } from '$lib/types'
import type { CalculatedDocDiscount } from '$lib/types/client_types'

import type { DocShippingItem, ServerDocShippingItem } from '../doc_shipping_items/types'

export enum EstimateStatus {
	Loading = '',
	Draft = 'draft',
	Sent = 'sent',
	Viewed = 'viewed',

	Approved = 'approved',
	Invoiced = 'invoiced',

	Deleted = 'deleted',
	Error = 'error'
}

// export type EstimateItem = DocumentItem

// export type EstimateItemOptions = Partial<EstimateItem>

export type EstimateTax = {
	id: string
	estimate_id: string
	tax_id: string
	idx: number
	name: string
	rate: Big
	type: TaxType
	total: Big
	business_id: string
}
export type EstimateTaxOptions = Partial<EstimateTax>

export type EstimateDiscount = CalculatedDocDiscount

export type Estimate = {
	account_id: string
	archived: boolean
	approved: boolean
	invoiced: boolean
	color: string
	due: string
	heading: string
	id: string
	issued: string
	notes: string
	number: string
	// items: DocumentItem[]
	items: CalculatedDocumentItem[]
	items_delete: string[]
	shipping_items: DocShippingItem[]
	shipping_items_delete: string[]
	discounts: EstimateDiscount[]
	// taxes: EstimateTax[]
	taxes: DocTax[]
	subtotal: Big
	discount: Big
	tax: Big
	grand_total: Big
	reference: string
	status: EstimateStatus //string // TODO typify
	terms: string
	//last_sent_at: string;
	last_sent_at: NullTime | null
	last_viewed_at: string
	last_deleted_at: string
	original_number: string
	currency_id: string
	has_attachments: boolean
	language_id: string,
	client_shipping_location_id: string | null
	
	last_saved_at: number
}

export type NullTime = {
	Time: string
	Valid: true
}

export type ServerEstimateLinkedInvoice = {
	id: string
	number: string
}
 
export type EstimateParams = Partial<Estimate>

// export type ServerEstimateItemTaxTotal = {
// 	[tax_id: string]: string
// }

// export type ServerEstimateItem = {
// 	details: string
// 	id: string
// 	name: string
// 	price: string
// 	quantity: string
// 	subtotal: string
// 	tax_totals: ServerEstimateItemTaxTotal
// 	taxes: string[]
// 	total: string
// }

export type ServerEstimateDiscount = {
	fixed: string
	id: string
	name: string
	rate: string
	total: string
	type: CalculationType
}

export type ServerEstimateTax = {
	id: string
	estimate_id: string
	tax_id: string
	idx: number
	name: string
	rate: string
	type: TaxType
	total: string
	business_id: string
}

export type ServerEstimate = {
	id: string
	account_id: string
	status: EstimateStatus
	archived: boolean
	approved: boolean
	invoiced: boolean
	heading: string
	number: string
	reference: string
	issued: string
	due: string
	color: string
	items: ServerDocumentItem[]
	shipping_items: ServerDocShippingItem[]
	discounts: ServerEstimateDiscount[]
	taxes: ServerEstimateTax[]
	subtotal: string
	discount: string
	tax: string
	grand_total: string
	notes: string
	terms: string
	invoice_id: string
	last_sent_at: NullTime
	last_viewed_at: string
	last_deleted_at: string
	original_number: string
	currency_id: string
	has_attachments: boolean
	language_id: string | null
	client_shipping_location_id: string | null
}

export type ButtonsHeader = {
	id: string
	text: string
	cmd: object
	classBtn: BUTTON_TYPE
	visible: boolean
}

export type ButtonsHeaderOptions = Partial<ButtonsHeader>
